module.exports = __webpack_public_path__ + "static/media/brand-center.29c239dd.svg";